<template lang="pug">
.header-user
  .in(v-if="logged")
    .avatar-warpper(
      @mouseover.prevent="handleMoveenter",
      @mouseleave.prevent="handleMoveleave"
    )
      img.avatar(:src="userinfo.headUrl", @error="imgError($event)")
    .more-wrapper(
      v-if="showList",
      @mouseover.prevent="handleMoveenter",
      @mouseleave.prevent="handleMoveleave"
    )
      ul.more-list.navs
        .li
          .info
            img.avatar(:src="userinfo.headUrl", @error="imgError($event)")
            div
              idv {{ userinfo.name }}
        li.tag_box
          .tag {{ levelName }}
        li(v-for="nav in navs")
          router-link(:to="{ name: nav.key }") {{ nav.name }}
        li
          .logout(@click.prevent="logout") 退出
</template>

<script>
import { navigators } from '@index/config/config'
export default {
  name: 'HeaderUser',
  data () {
    return {
      navs: navigators,
      timeHandle: null,
      showList: false,
      can: false
    }
  },
  computed: {
    levelName () {
      return this.$store.getters.levelName
    },
    logged () {
      return this.$store.getters.logged
    },
    isVip () {
      return this.$store.getters.isVip
    },
    user () {
      return this.$store.state.user
    },
    userinfo () {
      return this.$store.state.user.userinfo
    }
  },
  created () {
    this.showList = false
  },
  methods: {
    logout () {
      this.showList = false
      this.$store.dispatch('UserLogout')
        .then(res => {
          this.$router.push({
            name: 'EventIndex'
          })
        })
    },
    handleMoveenter () {
      clearTimeout(this.timeHandle)
      this.showList = false
      if (this.logged) {
        this.showList = true
      }
    },
    handleMoveleave () {
      clearTimeout(this.timeHandle)
      this.timeHandle = setTimeout(() => {
        this.showList = false
      }, 500)
    },
    imgError (e) {
      e.target.src = '/static/avatar.png'
    }
  }
}
</script>
<style lang="scss" scoped>
.header-user {
  position: relative;
  margin-right: 80px;
  height: 40px;
}

.avatar-warpper {
  height: 40px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: #63c0de;
  font-size: 1rem;
}
.avatar {
  border-radius: 50%;
  width: 36px;
  height: 36px;
}

a {
  color: #666;
}

.more-list.navs a:hover {
  color: #3989cb;
}
.more-list.navs {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.06);
  .li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    margin-top: 10px;
    .info {
      display: flex;
      align-items: center;
      color: #666;
      font-size: 12px;
      .avatar {
        width: 30px;
        height: 30px;
        border: 1px solid #dcdcdc;
        margin-right: 10px;
      }
      span {
        color: #333;
      }
    }
  }
  .tag_box {
    padding: 20px 0;
    border-bottom: 1px solid #ddd;
    .tag {
      display: inline-block;
      padding: 2px 20px;
      background: #f59a23;
      color: #fff;
    }
  }
}
.logout {
  margin: 20px;
  padding: 5px 0;
  color: #000;
  font-size: 14px;
  background: #f5f5f5;
  &:hover {
    cursor: pointer;
    color: #3989cb;
  }
}
.logout:hover {
  cursor: pointer;
}

.more-wrapper {
  width: 172px;
  height: 234px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 101;
}
ul {
  width: 160px;
  position: absolute;
  top: 55px;
  left: 0;
  background: #fff;
  text-align: center;
  border: solid 1px rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  /*    &:before{
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      position: absolute;
      background: #1c1d2d;
      left: 50%;
      top: -10px;
      margin-left: -10px;
      transform: rotate(45deg);
      border-top: 1px solid rgba(255, 255, 255, 0.2);
      border-left: 1px  solid rgba(255, 255, 255, 0.2);
    }*/
  li {
    line-height: 1.5;
    a {
      display: block;
      height: 100%;
      padding: 10px 0;
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/HeaderUser.vue